<template>
  <div>
    <b-card
      title=""
      no-body
    >
      <b-card-body>
        <!-- <div class="d-flex justify-content-between  flex-wrap"> -->
        <b-form @submit.prevent>
          <b-row>
            <b-col md="6">
              <b-form-group
                label="บัญชี"
                label-for="mc-first-name"
              >
                <v-select
                  v-model="tableQuery.bankaccount"
                  label="title"
                  :options="bankaccounts"
                >
                  <template #option="data">
                    <span>{{ data.acc_type.replace('IN','ฝาก').replace('OUT','ถอน') }} {{ bankMaps[data.bank_code] }} {{ data.acc_no }} {{ data.acc_name }}</span>
                  </template>
                </v-select>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="วันที่รายการ"
                label-for="mc-country"
              >
                <b-row>
                  <b-col md="6">
                    <flat-pickr
                      v-model="tableQuery.startdate"
                      class="form-control"
                      :config="{ enableTime: true,dateFormat: 'Y-m-d H:i', time_24hr: true, minuteIncrement:1 }"
                    />
                  </b-col>
                  <b-col md="6">
                    <flat-pickr
                      v-model="tableQuery.enddate"
                      class="form-control"
                      :config="{ enableTime: true,dateFormat: 'Y-m-d H:i', time_24hr: true, minuteIncrement:1 }"
                    />
                  </b-col>
                </b-row>
              </b-form-group>
            </b-col>
            <!-- submit and reset -->
            <b-col>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mr-1"
                @click="fetchSystemStatement"
              >
                ค้นหา
              </b-button>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="reset"
                variant="outline-secondary"
                @click="clearSearch"
              >
                เคลียร์
              </b-button>
            </b-col>
          </b-row>
        </b-form>
        <!-- </div> -->
      </b-card-body>
    </b-card>
    <b-row>
      <b-col
        v-if="statementItems.length > 0"
        xl="12"
        md="12"
      >
        <b-card
          no-body
          class="card-statistics"
        >
          <b-card-header>
            <b-card-title>สถิติรายการ</b-card-title>
            <b-card-text class="font-small-2 mr-25 mb-0">
              Updated 1 mins ago
            </b-card-text>
          </b-card-header>
          <b-card-body class="statistics-body">
            <b-row>
              <b-col
                v-for="item in stats"
                :key="item.icon"
                xl="3"
                sm="6"
                :class="item.customClass"
              >
                <b-media no-body>
                  <b-media-aside

                    class="mr-2"
                  >
                    <b-avatar
                      size="48"
                      :variant="item.color"
                    >
                      <feather-icon
                        size="24"
                        :icon="item.icon"
                      />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body class="my-auto">
                    <h4 class="font-weight-bolder mb-0">
                      {{ item.title }}
                    </h4>
                    <b-card-text class="font-small-3 mb-0">
                      {{ item.subtitle }}
                    </b-card-text>
                  </b-media-body>
                </b-media>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col md="12">
        <b-card
          title="รายการที่ระบบทำรายการ"
        >
          <b-row>
            <b-col md="12">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mr-1 mb-1"
                @click="saveToExcel()"
              >
                ดึง Excel
              </b-button>

              <b-form-checkbox
                v-model="isTimeFixedNeeded"
                class="mr-0 mt-50"
                name="is-rtl"
                inline
              /> ปรับเวลาเพิ่ม +7 (สำหรับกรณีเวลาไม่ตรง)
            </b-col>
          </b-row>
          <b-table
            ref="statementTable"
            striped
            hover
            responsive
            class="position-relative"
            :busy.sync="isBusy"
            :per-page="2000"
            :current-page="1"
            :items="statementItems"
            :fields="statementsTableFields"
          >
            <template #cell(amount)="data">
              <div :style="`text-align: right; ${(data.item.tx_type === 'OUT' ? 'color: red;':'')}`">
                {{ `${numberWithCommas(data.item.amount)}` }}
              </div>
            </template>
            <template #cell(detail)="data">
              <div :style="`${(data.item.detail.indexOf('เติมเงิน') >= 0 ? 'color: red;':'')}`">
                {{ `${data.item.detail}` }}
              </div>
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
// import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BCard, BTable, BBadge, BFormGroup, BFormSelect, BButton, BCardBody, BRow, BCol, BForm, BCardHeader, BCardTitle, BCardText, BMedia, BMediaAside, BAvatar, BMediaBody, BFormCheckbox,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import moment from 'moment'

export default {
  components: {
    BCard,
    BTable,
    // BBadge,
    BFormGroup,
    BFormCheckbox,
    // BFormSelect,
    // BPagination,
    // BInputGroup,
    // BFormInput,
    // BInputGroupAppend,
    BButton,
    BCardBody,
    BRow,
    BCol,
    BForm,
    vSelect,
    flatPickr,
    BCardHeader,
    BCardTitle,
    BCardText,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      bankaccounts: [],
      statementItems: [],
      isBusy: false,
      isTimeFixedNeeded: false,
      refRecheck: null,
      totalRows: 1,
      bankMaps: {
        '004': 'kbank', '014': 'scb', '006': 'krungthai', TMW: 'tmw',
      },
      tableQuery: {
        bankaccount: null,
        startdate: moment().format('YYYY-MM-DD 00:00:00'),
        enddate: moment().add(1, 'days').format('YYYY-MM-DD 00:00:00'),
      },
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      stats: [
        {
          color: 'light-primary',
          customClass: 'mb-2 mb-xl-0',
          icon: 'TrendingUpIcon',
          subtitle: 'จำนวนรายการ',
          title: '',
        },
        {
          color: 'light-success',
          customClass: '',
          icon: 'DollarSignIcon',
          subtitle: 'จำนวนเงิน',
          title: '',
        },
        {
          color: 'light-primary',
          customClass: 'mb-2 mb-xl-0',
          icon: 'TrendingUpIcon',
          subtitle: 'จำนวนรายการไม่ออโต้',
          title: '-',
        },
        {
          color: 'light-success',
          customClass: '',
          icon: 'DollarSignIcon',
          subtitle: 'จำนวนเงินไม่ออโต้',
          title: '-',
        },
      ],
      statementsTableFields: [
        { key: 'approved_datetime', label: 'วันที่', formatter: val => moment(val).format('DD/MM/YYYY HH:mm:ss') },
        { key: 'detail', label: 'รายการ' },
        { key: 'amount', label: 'จำนวนเงิน' },
        { key: 'username', label: 'ยูสเซอร์', formatter: (val, k, item) => `${item.phoneno}\t\n${item.username}` },
        { key: 'fullname', label: 'ชื่อลูกค้า' },
        // { key: 'match', label: 'จับคู่' },
        // { key: 'tx_acc', label: 'บัญชีฝาก' },
      ],
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },
  mounted() {
    // Set the initial number of items
    this.fetchBankAccounts()
  },
  methods: {
    clearSearch() {
      this.tableQuery = {
        bankaccount: null,
        startdate: moment().format('YYYY-MM-DD 00:00:00'),
        enddate: moment().add(1, 'days').format('YYYY-MM-DD 00:00:00'),
      }
      this.statementItems = []
    },
    async matchUser(bankTransferData) {
      console.log(bankTransferData)
    },
    async fetchSystemStatement() {
      if (this.tableQuery.bankaccount === null)
        return
      this.isBusy = true
      const { data: { statements, count, sum } } = await this.$http.post('botauto-statements', this.tableQuery)
      this.statementItems = statements
      this.stats[0].title = `${count}`
      this.stats[1].title = `${this.numberWithCommas(sum)}`

      const manualList = statements.filter(s => s.detail.indexOf('เติมเงิน') >= 0)
      let sumManual = 0
      manualList.forEach(manualItem => {
        sumManual += parseFloat(manualItem.amount)
      })
      this.stats[2].title = manualList.length
      this.stats[3].title = `${this.numberWithCommas(sumManual)}`
      this.isBusy = false
      // .filter(i => (i.processed === 'Y' && i.matched === 'Y'))
    },
    async fetchBankAccounts() {
      const { data: _bankaccounts } = await this.$http.get('bankaccounts')
      this.bankaccounts = _bankaccounts.bankaccounts.data.map(i => ({
        ...i, title: `${this.bankMaps[i.bank_code]} ${i.acc_no} ${i.acc_name}`, acc_type: i.acc_type, queue_name: i.bank_alias,
      }))
      this.bankaccounts.push({
        title: 'ทรูมันนี่', acc_no: '', bank_id: 'DEPOSIT-TMW', acc_name: 'ฝากทรูมันนี่', acc_type: 'IN',
      })
      this.bankaccounts.push({
        title: 'ถอนทรูมันนี่', acc_no: '', bank_id: 'WITHDRAW-TMW', acc_name: 'ถอนทรูมันนี่', acc_type: 'OUT', queue_name: 'TMW',
      })
      this.bankaccounts.push({
        title: 'ฝากเพย์เม้น', acc_no: '', bank_id: 'deposit-payment', acc_name: 'ฝากเพย์เม้น', acc_type: 'IN',
      })
      this.bankaccounts.push({
        title: 'ฝากมือ', acc_no: '', bank_id: 'deposit-manual', acc_name: 'ฝากมือ', acc_type: 'IN',
      })
      this.bankaccounts.push({
        title: 'ถอนมือ', acc_no: '', bank_id: 'withdraw-manual', acc_name: 'ถอนมือ', acc_type: 'OUT', queue_name: 'M',
      })
      this.bankaccounts.push({
        title: 'โปรโมชั่น', acc_no: 'promotion', bank_id: 'promotion', acc_name: 'โปรโมชั่น', acc_type: 'IN', queue_name: 'M',
      })
      this.bankaccounts.push({
        title: 'ตัดเครดิต/ยึดเครดิต', acc_no: '', bank_id: 'deduction', acc_name: 'ตัดเครดิต/ยึดเครดิต', acc_type: 'DEDUCTION',
      })
      // this.bankaccounts
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        // Add col name which needs to be translated
        if (j === 'approved_datetime') {
          return moment(v[j]).format('DD/MM HH:mm')
        }
        return v[j]
      }))
    },
    saveToExcel() {
      import('@/libs/Export2Excel').then(excel => {
        const headerTitle = ['วันที่เวลา', 'รายละเอียด', 'จำนวน', 'ยูสเซอร์', 'เบอร์โทร', 'ชื่อนามสกุล']
        const headerVal = ['approved_datetime', 'detail', 'amount', 'username', 'phoneno', 'fullname']
        const data = this.formatJson(headerVal, this.statementItems)
        excel.export_json_to_excel({
          header: headerTitle,
          data,
          filename: `${this.tableQuery.bankaccount.title}-${this.tableQuery.startdate}`,
          autoWidth: true,
          bookType: 'xlsx',
        })
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
// @import '@core/scss/vue/pages/dashboard-ecommerce.scss';
// @import '@core/scss/vue/libs/chart-apex.scss';
</style>
